import { FC } from "react";
import { InvoiceTarget } from "../model/registrationEnums";
import {
  SelectFormField,
  TextFormField,
} from "@blanket/components/formFields/FormFields";

type InvoiceDispatchFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  /** Den valgte kanal styrer hvilket detaljefelt der vises. */
  invoiceTarget: string;
};

/**
 * Hvordan fakturaer sendes, plus den ene detalje den valgte kanal kræver.
 * Fakturamailen arver ikke virksomhedens mail — "Mail" kræver sin egen adresse.
 *
 * Bemærk at enum-værdierne ER de danske labels: de sendes som strenge til API
 * og printes ordret i PDF'en.
 */
export const InvoiceDispatchFields: FC<InvoiceDispatchFieldsProps> = ({
  namePrefix,
  idPrefix,
  invoiceTarget,
}) => (
  <>
    <SelectFormField
      name={`${namePrefix}.invoiceTarget`}
      label="Angiv, hvordan fakturaer fra Advokatsamfundet skal sendes"
      id={`${idPrefix}-input-invoice-target`}
      isRequired
      options={[
        { value: InvoiceTarget.EBoks, label: "E-boks" },
        { value: InvoiceTarget.Mail, label: "Mail" },
        { value: InvoiceTarget.Brev, label: "Brev" },
        { value: InvoiceTarget.EAN, label: "EAN" },
      ]}
    />
    {invoiceTarget === InvoiceTarget.Mail && (
      <TextFormField
        name={`${namePrefix}.invoiceEmail`}
        label="E-mailadresse til modtagelse af fakturaer fra Advokatsamfundet"
        id={`${idPrefix}-input-invoice-email`}
        isRequired
        type="email"
      />
    )}
    {invoiceTarget === InvoiceTarget.EAN && (
      <TextFormField
        name={`${namePrefix}.eanNumber`}
        label="EAN-nummer"
        id={`${idPrefix}-input-ean-number`}
        isRequired
        type="number"
        helperText="EAN-nummeret er 13 cifre."
      />
    )}
  </>
);
